import React from 'react';
import { Button, DatePicker, Form, Input, Select } from 'antd';

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function OrderListFilters(props) {
    const { formRef, onChange, onReset, assigneeOptions = [] } = props;

    return (
        <div className="order-list-filters">
            <div className="order-list-filters__surface">
                <div className="order-list-filters__header">
                    <div>
                        <div className="order-list-filters__title">Bộ lọc đơn hàng</div>
                        <div className="order-list-filters__subtitle">Khoanh vùng nhanh danh sách cần xử lý</div>
                    </div>
                </div>
                <Form
                    ref={formRef}
                    layout="vertical"
                    onChange={onChange}
                    initialValues={{ status: '', assignee_id: '', assigned_state: '' }}
                    className="order-list-filters__form"
                >
                    <div className="row order-list-filters__row">
                        <div className="col-md-3">
                            <Form.Item name="order_code" label="Mã đơn" className="order-list-filters__item">
                                <Input placeholder="ORD-001" className="order-list-filters__input" />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="customer_name" label="Khách hàng" className="order-list-filters__item">
                                <Input placeholder="Tên khách hàng" className="order-list-filters__input" />
                            </Form.Item>
                        </div>
                        <div className="col-md-2">
                            <Form.Item name="phone" label="SĐT" className="order-list-filters__item">
                                <Input placeholder="0909..." className="order-list-filters__input" />
                            </Form.Item>
                        </div>
                        <div className="col-md-2">
                            <Form.Item name="status" label="Trạng thái" className="order-list-filters__item">
                                <Select className="order-list-filters__select">
                                    <Option value="">Tất cả</Option>
                                    <Option value="draft">Draft</Option>
                                    <Option value="confirmed">Confirmed</Option>
                                    <Option value="cancelled">Cancelled</Option>
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-md-2">
                            <Form.Item name="assigned_state" label="Phân công" className="order-list-filters__item">
                                <Select className="order-list-filters__select">
                                    <Option value="">Tất cả</Option>
                                    <Option value="unassigned">Chưa assign</Option>
                                    <Option value="assigned_to_me">Của tôi</Option>
                                    <Option value="assigned_to_others">Người khác</Option>
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row order-list-filters__row">
                        <div className="col-md-3">
                            <Form.Item name="assignee_id" label="Người xử lý" className="order-list-filters__item">
                                <Select className="order-list-filters__select">
                                    <Option value="">Tất cả</Option>
                                    {assigneeOptions.map((item) => (
                                        <Option key={item.user_id} value={item.user_id}>{item.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item name="created_range" label="Ngày tạo" className="order-list-filters__item">
                                <RangePicker className="order-list-filters__range" style={{ width: '100%' }} format="DD/MM/YYYY" />
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item name="confirmed_range" label="Ngày xác nhận" className="order-list-filters__item">
                                <RangePicker className="order-list-filters__range" style={{ width: '100%' }} format="DD/MM/YYYY" />
                            </Form.Item>
                        </div>
                        <div className="col-md-1 d-flex align-items-end">
                            <Button className="order-list-filters__reset" onClick={onReset}>Xóa lọc</Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
}
